// Import Context
import createAppContext from "./createAppContext";

// Import Utils
import aType from "../utils/ActionTypes";

// Import Reducer
import userReducer from "./reducer";

// User Actions
const setContextWelcome = (dispatch) => async (showWelcome) => {
    dispatch({ type: aType.SET_WELCOME, payload: showWelcome })
}

// Export Methods with Create Context
export const { Provider, Context } = createAppContext(
    userReducer,
    { setContextWelcome },
    { showWelcome: true }
)